import { parseDocumentCommentsListResponse } from "./parseDocumentCommentsListResponse";
import type { DocumentComment } from "./types";

/** The list API pages by thread root (newest first) and returns every reply of each root. */
export const COMMENT_THREADS_PAGE_SIZE = 500;
/** Open comment lists refetch this often so collaborators' comments show up without a reload. */
export const COMMENT_LIST_POLL_MS = 30_000;
/** Safety stop: 20 pages is 10,000 threads. */
const MAX_PAGES = 20;

type CommentListParams = Record<string, string | number>;

/**
 * Loads every thread on a document, one page of roots at a time. A page with fewer roots than
 * the page size is the last. Rows are deduped by id, since a comment posted mid-load can shift
 * a root onto the next page.
 */
export async function fetchAllDocumentComments(
  getPage: (params: CommentListParams) => Promise<unknown>,
  params: CommentListParams = {}
): Promise<DocumentComment[]> {
  const byId = new Map<string, DocumentComment>();
  for (let page = 0; page < MAX_PAGES; page++) {
    const rows = parseDocumentCommentsListResponse(
      await getPage({
        ...params,
        limit: COMMENT_THREADS_PAGE_SIZE,
        offset: page * COMMENT_THREADS_PAGE_SIZE,
      })
    );
    for (const row of rows) byId.set(row.comment_id, row);
    const roots = rows.filter((row) => !row.parent_comment_id).length;
    if (roots < COMMENT_THREADS_PAGE_SIZE) break;
  }
  return [...byId.values()];
}
